interface QuoteSummaryProps {
  subTotal: number;
  vat: number;
  total: number;
}

/**
 * 견적 합계 섹션 공통 컴포넌트
 * 공급가액, 세액, 합계금액을 표시
 */
export function QuoteSummary({ subTotal, vat, total }: QuoteSummaryProps) {
  return (
    <div className="flex justify-center sm:justify-end items-start mb-6 sm:mb-8">
      <table className="w-full sm:w-[280px] md:w-[300px] text-xs sm:text-sm md:text-sm">
        <tbody>
          <tr className="border-b border-gray-200">
            <td className="py-1.5 sm:py-2 text-gray-600 font-semibold">공급가액</td>
            <td className="py-1.5 sm:py-2 text-right font-medium text-gray-900 tabular-nums">
              ₩{subTotal.toLocaleString("ko-KR")}
            </td>
          </tr>
          <tr className="border-b border-gray-200">
            <td className="py-1.5 sm:py-2 text-gray-600 font-semibold">
              세액 (VAT)
            </td>
            <td className="py-1.5 sm:py-2 text-right font-medium text-gray-900 tabular-nums">
              ₩{vat.toLocaleString("ko-KR")}
            </td>
          </tr>
          <tr className="border-b-2 border-primary">
            <td className="py-2 sm:py-2.5 md:py-3 text-primary-text font-semibold text-sm sm:text-base md:text-base">
              합계금액
            </td>
            <td className="py-2 sm:py-2.5 md:py-3 text-right font-semibold text-primary-text text-base sm:text-lg md:text-lg tabular-nums">
              ₩{total.toLocaleString("ko-KR")}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
}
